export function downloadBookingCalendar(input: {
  title: string;
  startsAt: string;
  durationMinutes: number;
  status: string;
}): void {
  const start = new Date(input.startsAt);
  if (!Number.isFinite(start.getTime())) return;
  const end = new Date(start.getTime() + input.durationMinutes * 60_000);
  const status = input.status === "cancelled" ? "CANCELLED" : "CONFIRMED";
  const ics = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//HairBridge//Booking//KO",
    "CALSCALE:GREGORIAN",
    "BEGIN:VEVENT",
    `UID:${crypto.randomUUID()}@hairbridge.local`,
    `DTSTAMP:${utc(new Date())}`,
    `DTSTART:${utc(start)}`,
    `DTEND:${utc(end)}`,
    `STATUS:${status}`,
    `SUMMARY:${escapeIcs(input.title)}`,
    "DESCRIPTION:HairBridge 예약 일정입니다.",
    "END:VEVENT",
    "END:VCALENDAR",
    "",
  ].join("\r\n");
  const url = URL.createObjectURL(new Blob([ics], { type: "text/calendar;charset=utf-8" }));
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = "hairbridge-booking.ics";
  anchor.click();
  setTimeout(() => URL.revokeObjectURL(url), 0);
}

function utc(value: Date): string {
  return value.toISOString().replaceAll(/[-:]/g, "").replace(/\.\d{3}/, "");
}

function escapeIcs(value: string): string {
  return value.replaceAll("\\", "\\\\").replaceAll(";", "\\;").replaceAll(",", "\\,").replaceAll(/\r?\n/g, "\\n");
}
